import utility from "../lib/utility.js";
import moment from "moment";
const randomColor = require("randomcolor");
const state = {
  month_th: [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน ",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
  ],
  length_pie: [],
  options_pie: {
    legend: {
      position: "right"
    },
    responsive: true,
    title: {
      fontSize:18,
      fontFamily:'sans-serif',
      display: true,
      padding:40,
      text: ""
    },
    plugins: {
      datalabels: {
        formatter: (value, context) => {
          return (
            context.chart.data.labels[context.dataIndex] + " " + value + "%"
          );
        }
      }
    }
  },
  chartOptions_bar: {
    title: {
      display: true,
      fontSize:18,
      fontFamily:'sans-serif',
      padding: 40,
      text: "",
    },
    responsive: true,
    legend: {
      position: "right"
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: (value, context) => {
          return value;
        }
      }
    }
  },
  bar_pre: {
    labels: [],
    datasets: []
  },
  bar_post: {
    labels: [],
    datasets: []
  },
  bar_ontop: {
    labels: [],
    datasets: []
  },
  data_pie: {
    labels: ["Pre-Paid", "Post-Paid", "On-Top"],
    datasets: [
      {
        data: [],
        backgroundColor: [
          randomColor({
            format: "rgb",
            luminosity: "light"
          }),
          randomColor({
            format: "rgb",
            luminosity: "light"
          }),
          randomColor({
            format: "rgb",
            luminosity: "light"
          })
        ]
      }
    ]
  }
};
const actions = {
  report_month({ commit }, data) {
    return new Promise((resolve, reject) => {
      state.chartOptions_bar.title.text = "";
      state.bar_pre = {
        labels: [],
        datasets: []
      };
      state.bar_post = {
        labels: [],
        datasets: []
      };
      state.bar_ontop = {
        labels: [],
        datasets: []
      };
      commit("UPDATE_LENGTH_GRAP_MONTH", {
        month: data.month,
        service_providers: data.service_providers
      });
      resolve({
        data_pie: state.data_pie,
        bar_pre: state.bar_pre,
        bar_post: state.bar_post,
        bar_ontop: state.bar_ontop
      });
    });
  },
  report_year({ commit }, data) {
    state.chartOptions_bar.title.text = "";
    state.bar_pre = {
      labels: [],
      datasets: []
    };
    state.bar_post = {
      labels: [],
      datasets: []
    };
    state.bar_ontop = {
      labels: [],
      datasets: []
    };
    return new Promise((resolve, reject) => {
      commit("UPDATE_LENGTH_GRAP_YEAR", {
        year: data.year,
        service_providers: data.service_providers
      });
      resolve({
        data_pie: state.data_pie,
        bar_pre: state.bar_pre,
        bar_post: state.bar_post,
        bar_ontop: state.bar_ontop
      });
    });
  },
  report_between_year({ commit }, data) {
    state.chartOptions_bar.title.text = "";
    state.bar_pre = {
      labels: [],
      datasets: []
    };
    state.bar_post = {
      labels: [],
      datasets: []
    };
    state.bar_ontop = {
      labels: [],
      datasets: []
    };
    return new Promise((resolve, reject) => {
      let a = moment(new Date(data.yearfrom));
      let b = moment(new Date(data.yearto));
      let x = b.diff(a, "years") + 1;
      commit("UPDATE_LENGTH_BETWEEN_YEAR", {
        length_year: x,
        yearfrom: data.yearfrom,
        yearto: data.yearto,
        service_providers: data.service_providers
      });
      resolve({
        data_pie: state.data_pie,
        bar_pre: state.bar_pre,
        bar_post: state.bar_post,
        bar_ontop: state.bar_ontop
      });
    });
  },
  report_quarter({ commit }, data) {
    state.bar_pre = {
      labels: [],
      datasets: []
    };
    state.bar_post = {
      labels: [],
      datasets: []
    };
    state.bar_ontop = {
      labels: [],
      datasets: []
    };
    return new Promise((resolve, reject) => {
      commit("UPDATE_LENGTH_QUARTER", {
        quarter: data.quarter,
        quarter_year: data.quarter_year,
        service_providers: data.service_providers
      });
      resolve({
        data_pie: state.data_pie,
        bar_pre: state.bar_pre,
        bar_post: state.bar_post,
        bar_ontop: state.bar_ontop
      });
    });
  },
  report_between_month({ commit }, data) {
    state.chartOptions_bar.title.text = "";
    state.bar_pre = {
      labels: [],
      datasets: []
    };
    state.bar_post = {
      labels: [],
      datasets: []
    };
    state.bar_ontop = {
      labels: [],
      datasets: []
    };
    return new Promise((resolve, reject) => {
      let a = moment(new Date(data.monthfrom));
      let b = moment(new Date(data.monthto));
      let x = b.diff(a, "months") + 1;

      state.length_pie = [];
      for (var i = 0; i < data.service_providers.length; i++) {
        state.bar_pre.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
        state.bar_post.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
        state.bar_ontop.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      }
      for (var i = 0; i < x; i++) {
        var month_pie =
          "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  เดือน " +
          state.month_th[(parseInt(moment(new Date(data.monthfrom)).format("MM")) + i)-1];
        state.length_pie.push({
          text_pie: "pie" + i,
          year: month_pie + " ปี "  + moment(new Date(data.monthfrom)).format("YYYY")
        });

        var color = randomColor({
          format: "rgb",
          luminosity: "light"
        });

        var month =
          "เดือน " +
          state.month_th[(parseInt(moment(new Date(data.monthfrom)).format("MM")) +i)-1];
        state.bar_pre.datasets.push({
          label:
            "Pre-Paid " +
            month +
            "/" +
            moment(new Date(data.monthfrom)).format("YYYY"),
          backgroundColor: color,
          borderWidth: 1,
          data: utility.randomNumber(data.service_providers.length)
        });
        state.bar_post.datasets.push({
          label:
            "Post-Paid " +
            month +
            "/" +
            moment(new Date(data.monthfrom)).format("YYYY"),
          backgroundColor: color,
          borderWidth: 1,
          data: utility.randomNumber(data.service_providers.length)
        });
        state.bar_ontop.datasets.push({
          label:
            "On-top " +
            month +
            "/" +
            moment(new Date(data.monthfrom)).format("YYYY"),
          backgroundColor: color,
          borderWidth: 1,
          data: utility.randomNumber(data.service_providers.length)
        });
      }
      state.data_pie.datasets[0].data[0] = 25;
      state.data_pie.datasets[0].data[1] = 31;
      state.data_pie.datasets[0].data[2] = 44;
      resolve({
        data_pie: state.data_pie,
        bar_pre: state.bar_pre,
        bar_post: state.bar_post,
        bar_ontop: state.bar_ontop
      });
    });
  },
  report_quarterss({ commit }, data) {
    state.bar_pre = {
      labels: [],
      datasets: []
    };
    state.bar_post = {
      labels: [],
      datasets: []
    };
    state.bar_ontop = {
      labels: [],
      datasets: []
    };

    return new Promise((resolve, reject) => {
      state.length_pie = [];
      var quarterfrom = parseInt(data.quarterfrom);
      var quarterto = parseInt(data.quarterto);
      let a = moment(new Date(data.quarter_year_from));
      let b = moment(new Date(data.quarter_year));
      let x = b.diff(a, "years");
      for (var j = 0; j < data.service_providers.length; j++) {
        state.bar_pre.labels.push("กลุ่มบริษัท " + data.service_providers[j]);
        state.bar_post.labels.push("กลุ่มบริษัท " + data.service_providers[j]);
        state.bar_ontop.labels.push("กลุ่มบริษัท " + data.service_providers[j]);
      }
      // state.chartOptions_bar.title.text =
      // "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  ไตรมาสที่ " +
      // data.quarterfrom + " ปี " + moment(new Date(data.quarter_year_from)).format("YYYY")+' - ไตรมาสที่ '+ data.quarterto + ' ปี '+moment(new Date(data.quarter_year)).format("YYYY")

      var m = 0;
      // ลูบปี
      for (var i = 0; i <= x; i++) {
        console.log(i + "===" + x);
        if (i === 0) {
          for (quarterfrom; quarterfrom < quarterto + 1; quarterfrom++) {
            state.length_pie.push({
              text_pie: "pie" + m,
              year:
                "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  ไตรมาสที่ " +
                quarterfrom +
                " ปี " +
                moment(new Date(data.quarter_year_from))
                  .add(i, "y")
                  .format("YYYY")
            });
            m++;

            var color = randomColor({
              format: "rgb",
              luminosity: "light"
            });
            var year =
              "ไตรมาสที่ " +
              quarterfrom +
              " ปี " +
              moment(new Date(data.quarter_year_from))
                .add(i, "y")
                .format("YYYY");

            state.bar_pre.datasets.push({
              label: "Pre-Paid " + year,
              backgroundColor: color,
              borderWidth: 1,
              data: utility.randomNumber(data.service_providers.length)
            });
            state.bar_post.datasets.push({
              label: "Post-Paid " + year,
              backgroundColor: color,
              borderWidth: 1,
              data: utility.randomNumber(data.service_providers.length)
            });
            state.bar_ontop.datasets.push({
              label: "On-Top " + year,
              backgroundColor: color,
              borderWidth: 1,
              data: utility.randomNumber(data.service_providers.length)
            });
          }
        } else {
          for (var n = 1; n < quarterto + 1; n++) {
            state.length_pie.push({
              text_pie: "pie" + m,
              year:
                "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่ ไตรมาสที่" +
                n +
                " ปี " +
                moment(new Date(data.quarter_year_from))
                  .add(i, "y")
                  .format("YYYY")
            });
            m++;
            var color = randomColor({
              format: "rgb",
              luminosity: "light"
            });
            var year =
              "ไตรมาสที่" +
              n +
              " ปี " +
              moment(new Date(data.quarter_year_from))
                .add(i, "y")
                .format("YYYY");

            state.bar_pre.datasets.push({
              label: "Pre-Paid " + year,
              backgroundColor: color,
              borderWidth: 1,
              data: utility.randomNumber(data.service_providers.length)
            });
            state.bar_post.datasets.push({
              label: "Post-Paid " + year,
              backgroundColor: color,
              borderWidth: 1,
              data: utility.randomNumber(data.service_providers.length)
            });
            state.bar_ontop.datasets.push({
              label: "On-Top " + year,
              backgroundColor: color,
              borderWidth: 1,
              data: utility.randomNumber(data.service_providers.length)
            });
          }
        }
        state.data_pie.datasets[0].data[0] = 25;
        state.data_pie.datasets[0].data[1] = 31;
        state.data_pie.datasets[0].data[2] = 44;
        var quarterfrom = parseInt(data.quarterfrom);
      }
      // console.log(state.data_pie)
      commit("UPDATE_LENGTH_QUARTERSS", {
        // quarterform: quarterfrom,
        // quarterto: quarterto,
        // quarter_year: data.quarter_year,
        // service_providers: data.service_providers,
        // quarter_year_from: data.quarter_year_from
      });
      resolve({
        data_pie: state.data_pie,
        bar_pre: state.bar_pre,
        bar_post: state.bar_post,
        bar_ontop: state.bar_ontop
      });
    });
  }
};

const mutations = {
  UPDATE_LENGTH_GRAP_MONTH(state, data) {
    state.length_pie = [];
    state.length_pie.push({
      text_pie: "pie0",
      year:
        "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  เดือน " + state.month_th[parseInt(moment(new Date(data.month)).format("MM"))-1] + ' ปี '+moment(new Date(data.month)).format("YYYY")
    });
    state.data_pie.datasets[0].data[0] = 50;
    state.data_pie.datasets[0].data[1] = 30;
    state.data_pie.datasets[0].data[2] = 20;

    for (var i = 0; i < data.service_providers.length; i++) {
      state.bar_pre.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_post.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_ontop.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
    }
    
    state.bar_pre.datasets.push({
      label: "Pre-Paid เดือน " + state.month_th[parseInt(moment(new Date(data.month)).format("MM"))-1] + ' ปี '+moment(new Date(data.month)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });

    state.bar_post.datasets.push({
      label: "Post-Paid เดือน " + state.month_th[parseInt(moment(new Date(data.month)).format("MM"))-1] + ' ปี '+moment(new Date(data.month)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
   
    state.bar_ontop.datasets.push({
      label: "On-Top เดือน " + state.month_th[parseInt(moment(new Date(data.month)).format("MM"))-1] + ' ปี '+moment(new Date(data.month)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
  },
  UPDATE_LENGTH_GRAP_YEAR(state, data) {
    state.length_pie = [];
    state.length_pie.push({
      text_pie: "pie0",
      year:
        "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  ปี " +
        moment(new Date(data.year)).format("YYYY")
    });
    state.data_pie.datasets[0].data[0] = 30;
    state.data_pie.datasets[0].data[1] = 30;
    state.data_pie.datasets[0].data[2] = 40;

    for (var i = 0; i < data.service_providers.length; i++) {
      state.bar_pre.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_post.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_ontop.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
    }

    state.bar_pre.datasets.push({
      label: "Pre-Paid " + moment(new Date(data.year)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
    state.bar_post.datasets.push({
      label: " Post-Paid " + moment(new Date(data.year)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
    state.bar_ontop.datasets.push({
      label: "On-Top " + moment(new Date(data.year)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
  },
  UPDATE_LENGTH_BETWEEN_YEAR(state, data) {
    state.length_pie = [];
    for (var i = 0; i < data.service_providers.length; i++) {
      state.bar_pre.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_post.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_ontop.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
    }
    state.chartOptions_bar.title.text =
      "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  ปี " +
      moment(new Date(data.yearfrom)).format("YYYY") +
      " - ปี " +
      moment(new Date(data.yearto)).format("YYYY");
    for (var i = 0; i < data.length_year; i++) {
      var year = parseInt(moment(new Date(data.yearfrom)).format("YYYY")) + i;
      state.length_pie.push({
        text_pie: "pie" + i,
        year: "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่ ปี " + year
      });

      var color = randomColor({
        format: "rgb",
        luminosity: "light"
      });

      state.bar_pre.datasets.push({
        label: "Pre-Paid " + year,
        backgroundColor: color,
        borderWidth: 1,
        data: utility.randomNumber(data.service_providers.length)
      });
      state.bar_post.datasets.push({
        label: "Post-Paid " + year,
        backgroundColor: color,
        borderWidth: 1,
        data: utility.randomNumber(data.service_providers.length)
      });
      state.bar_ontop.datasets.push({
        label: "On-Top " + year,
        backgroundColor: color,
        borderWidth: 1,
        data: utility.randomNumber(data.service_providers.length)
      });
    }
    state.data_pie.datasets[0].data[0] = 25;
    state.data_pie.datasets[0].data[1] = 31;
    state.data_pie.datasets[0].data[2] = 44;
  },
  UPDATE_LENGTH_QUARTER(state, data) {
    state.length_pie = [];
    state.length_pie.push({
      text_pie: "pie0",
      year:
        "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่ ไตรมาสที่" +
        data.quarter +
        " " +
        moment(new Date(data.quarter_year)).format("YYYY")
    });
    state.data_pie.datasets[0].data[0] = 15;
    state.data_pie.datasets[0].data[1] = 46;
    state.data_pie.datasets[0].data[2] = 39;

    for (var i = 0; i < data.service_providers.length; i++) {
      state.bar_pre.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_post.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
      state.bar_ontop.labels.push("กลุ่มบริษัท " + data.service_providers[i]);
    }

    // state.chartOptions_bar.title.text =
    //   "รายงานเปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่  ไตรมาสที่ " +
    //   data.quarter +
    //   " ปี " +
    //   moment(new Date(data.quarter_year)).format("YYYY");

    state.bar_pre.datasets.push({
      label:
        "Pre-Paid " +
        "Q" +
        data.quarter +
        " " +
        moment(new Date(data.quarter_year)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
    state.bar_post.datasets.push({
      label:
        "Post-Paid " +
        "Q" +
        data.quarter +
        " " +
        moment(new Date(data.quarter_year)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
    state.bar_ontop.datasets.push({
      label:
        "On-Top " +
        "Q" +
        data.quarter +
        " " +
        moment(new Date(data.quarter_year)).format("YYYY"),
      backgroundColor: randomColor({
        format: "rgb",
        luminosity: "light"
      }),
      borderWidth: 1,
      data: utility.randomNumber(data.service_providers.length)
    });
  },
  UPDATE_LENGTH_QUARTERSS(state, data) {}
};

export const Report_pcp = {
  namespaced: true,
  state,
  actions,
  mutations
};
